import Movie from "./common/classes/movie.es6";
import Modal from "./common/classes/modal.es6";
import Header from "./common/classes/header.es6";
import CableDraw from "./common/classes/cableDraw.es6";

export default class Common {
    constructor() {
        this.movie = new Movie();
        this.modal = new Modal();
        this.header = new Header();
        this.pageBgLine = new CableDraw({
            selector: ".l-page-main__bgline-item",
            trigger: "load",
            duration: window.matchMedia("(min-width: 781px)").matches ? 1.2 : 1.5,
            ease: "power1.in",
            skipAnimation: document.documentElement.classList.contains("-same-subpage-transition"),
        });

        this.init();
    }

    init() {
        const onLoad = () => {
            document.body.classList.add("-load");
            this.playPageTitleApng();
        };

        if (document.readyState === "complete") {
            onLoad();
        } else {
            window.addEventListener("load", onLoad, { once: true });
        }
    }

    // APNGが初回描画前に再生終了しないよう、load完了後に画像URLを設定する
    playPageTitleApng() {
        if (document.documentElement.classList.contains("-same-subpage-transition")) return;

        document.querySelectorAll(".l-page-main__title-apng").forEach((picture) => {
            requestAnimationFrame(() => {
                picture.classList.add("-active");

                picture.querySelectorAll("source[data-srcset]").forEach((source) => {
                    source.srcset = source.dataset.srcset;
                    source.removeAttribute("data-srcset");
                });

                picture.querySelectorAll("img[data-src]").forEach((img) => {
                    img.src = img.dataset.src;
                    img.removeAttribute("data-src");
                });
            });
        });
    }
}

const common = new Common();
